module.exports = __webpack_public_path__ + "media/assets/plus_bold-a3e96e2d8387f67651c6ba1a5e7471a5.svg";